const dataAllocation = [
  { investor: 'Investor 1', allocation: 'Order Book', amount: 42500000 },
  { investor: 'Investor 2', allocation: 'Order Book', amount: 37000000 },
  { investor: 'Investor 3', allocation: 'Order Book', amount: 31000000 },
  { investor: 'Investor 4', allocation: 'Order Book', amount: 28000000 },
  { investor: 'Investor 5', allocation: 'Order Book', amount: 25500000 },
  { investor: 'Investor 6', allocation: 'Order Book', amount: 23500000 },
  { investor: 'Investor 7', allocation: 'Order Book', amount: 18500000 },
  { investor: 'Investor 8', allocation: 'Order Book', amount: 16500000 },
  { investor: 'Investor 9', allocation: 'Order Book', amount: 14500000 },
  { investor: 'Investor 10', allocation: 'Order Book', amount: 13000000 },

  {
    investor: 'Investor 1',
    allocation: 'Proposed Allocation',
    amount: 38300000
  },
  {
    investor: 'Investor 2',
    allocation: 'Proposed Allocation',
    amount: 18600000
  },
  {
    investor: 'Investor 3',
    allocation: 'Proposed Allocation',
    amount: 27900000
  },
  {
    investor: 'Investor 4',
    allocation: 'Proposed Allocation',
    amount: 22400000
  },
  {
    investor: 'Investor 5',
    allocation: 'Proposed Allocation',
    amount: 12800000
  },
  {
    investor: 'Investor 6',
    allocation: 'Proposed Allocation',
    amount: 11800000
  },
  {
    investor: 'Investor 7',
    allocation: 'Proposed Allocation',
    amount: 16700000
  },
  {
    investor: 'Investor 8',
    allocation: 'Proposed Allocation',
    amount: 8300000
  },
  {
    investor: 'Investor 9',
    allocation: 'Proposed Allocation',
    amount: 11600000
  },
  {
    investor: 'Investor 10',
    allocation: 'Proposed Allocation',
    amount: 6600000
  },

  {
    investor: 'Investor 1',
    allocation: 'Revised Allocation',
    amount: 35800000
  },
  {
    investor: 'Investor 2',
    allocation: 'Revised Allocation',
    amount: 21100000
  },
  {
    investor: 'Investor 3',
    allocation: 'Revised Allocation',
    amount: 25900000
  },
  {
    investor: 'Investor 4',
    allocation: 'Revised Allocation',
    amount: 24400000
  },
  {
    investor: 'Investor 5',
    allocation: 'Revised Allocation',
    amount: 13800000
  },
  { investor: 'Investor 6', allocation: 'Revised Allocation', amount: 8800000 },
  {
    investor: 'Investor 7',
    allocation: 'Revised Allocation',
    amount: 16700000
  },
  { investor: 'Investor 8', allocation: 'Revised Allocation', amount: 6800000 },
  {
    investor: 'Investor 9',
    allocation: 'Revised Allocation',
    amount: 13100000
  },
  { investor: 'Investor 10', allocation: 'Revised Allocation', amount: 8600000 }
];

export default dataAllocation;
